import React, { useState } from "react";
import classes from "../assets/styles/Pages/Settings/AddNewPage.module.css";
import FormInput from "../components/Forms/FormInput";
import personicon from "../assets/images/signup_icons/personicon.svg";
import emailicon from "../assets/images/signup_icons/email.svg";
import { Button, Card } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import ValidateSchema from "../helpers/ValidateSchema";
import PackageContactFormSchema from "../utils/SchemasValidation/PackageContactFormSchema";
import { post } from "../server";
import showToast from "../helpers/showToast";
import { PACKAGE } from "../utils/constants/apiUrl";
import Loader from "../components/Loader";
import { trackEvent } from "../utils/mixpanel";

const PackageContactForm = ({ onClose, packageId: packageIdProp }) => {
  const { packageId: packageIdParam } = useParams();
  const packageId = packageIdProp || packageIdParam;
  const [contactForm, setContactForm] = useState({
    title: "",
    email: "",
    description: "",
    package_type: packageId === "7" ? "personal" : "owner",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setContactForm({ ...contactForm, [name]: value });
  };

  // handle Validation
  const validateForm = () => {
    let newErrors = ValidateSchema(contactForm, PackageContactFormSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    let contactObj = { ...contactForm, package_id: Number(packageId) };
    let { status, message } = await post(
      `${PACKAGE}/packageContactForm`,
      contactObj
    );
    if (status) {
      trackEvent("Package Contact Form Submitted", {
        outcome: "Success",
        message: "Request successfully sent",
        form_data: contactObj,
        timestamp: new Date().toISOString(),
      });
      showToast(status, "Request successfully send");
      setContactForm({
        title: "",
        email: "",
        description: "",
        package_type: "",
      });
      navigate(-1);
    } else {
      trackEvent("Package Contact Form Submitted", {
        outcome: "Failed",
        message,
        form_data: contactObj,
        timestamp: new Date().toISOString(),
      });
      showToast(status, message);
    }
    setLoading(false);
  };

  if (loading) return <Loader />;

  return (
    <>
      {/* <div className=""> */}
      {/* <h6 className="pageTitle">Contact Us</h6> */}
      {/* <button
          style={{ float: "right" }}
          className="primary_button"
          // onClick={() => navigate(-1)}
          onClick={onClose}
        >
          Go Back
        </button> */}
      {/* </div> */}
      {/* <div className={`mainWrapper subscriptionWrapper`}>
        <div className="row">
          <div className="col-md-6 col-12">
            <FormInput
              label="Title"
              type="text"
              name="title"
              placeholder="Enter Title"
              value={contactForm.title}
              handleChange={handleChange}
              error={errors?.title}
              icon={personicon}
              autofocus={true}
            />
          </div>
          <div className="col-md-6 col-12">
            <FormInput
              label="Email"
              type="text"
              name="email"
              placeholder="Email Address"
              value={contactForm.email}
              handleChange={handleChange}
              error={errors?.email}
              icon={emailicon}
            />
          </div>
          <div className="col-12">
            <label htmlFor="" className="label">
              Description
            </label>
            <textarea
              name="description"
              id=""
              cols="100"
              rows="10"
              value={contactForm.description}
              placeholder="Enter Description"
              onChange={handleChange}
              className={
                errors?.description
                  ? "globalTextArea errorInput"
                  : "globalTextArea"
              }
            />
            <p className="errorText">{errors?.description || ""}</p>
            <div className="formBottom">
              <Button
                className="submitButton"
                type="submit"
                onClick={handleSubmit}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div> */}
      {/* <div className="container vh-100">
        <div className="row h-100 align-items-center justify-content-center">
          <div className="col-12 col-lg-6"> */}
      <Card className="shadow">
        <Card.Header className="bg-transparent border-bottom-0 pt-4 pb-0">
          <h5 className="card-title">Contact Us</h5>
        </Card.Header>
        <Card.Body>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="row gx-3">
              <div className="col-md-12 col-12">
                <FormInput
                  label="Title"
                  type="text"
                  name="title"
                  placeholder="Enter Title"
                  value={contactForm.title}
                  handleChange={handleChange}
                  error={errors?.title}
                  // icon={personicon}
                  autofocus={true}
                />
              </div>

              <div className="col-md-12 col-12">
                <FormInput
                  label="Email"
                  type="text"
                  name="email"
                  placeholder="Email Address"
                  value={contactForm.email}
                  handleChange={handleChange}
                  error={errors?.email}
                  // icon={emailicon}
                />
              </div>

              <div className="col-12">
                <div className="form-group mb-4">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <textarea
                    name="description"
                    id="description"
                    rows="6"
                    value={contactForm.description}
                    placeholder="Enter Description"
                    onChange={handleChange}
                    className={
                      errors?.description
                        ? "globalTextArea errorInput w-100 form-control"
                        : "globalTextArea w-100 form-control"
                    }
                    style={{ resize: "vertical", maxWidth: "100%" }}
                  />
                  <p className="errorText">{errors?.description || ""}</p>
                </div>
              </div>

              <div className="col-12 text-end">
                <Button
                  className="mx-3"
                  type="submit"
                  variant="outline-primary"
                  onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                  className="submitButton"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Send
                </Button>
              </div>
            </div>
          </form>
        </Card.Body>
      </Card>
      {/* </div>
        </div>
      </div> */}
    </>
  );
};

export default PackageContactForm;

